// extracted by mini-css-extract-plugin
export default {"caption":"Text_caption__RlTeu","primary":"Text_primary__xIlSM"};